"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * update  customer information to an order
 * @param event of type InitiateOrderEvent
 * @param prevState
 */
function default_1(event, prevState = {}) {
    const order = prevState;
    order.customer = {
        ...order.customer,
        loyaltyMember: event.loyaltyMember,
    };
    order.isLoyaltyApplied = Boolean(event === null || event === void 0 ? void 0 : event.isLoyaltyApplied);
    return order;
}
exports.default = default_1;
//# sourceMappingURL=updateCustomerInfo.js.map